export default __webpack_public_path__ + "static/media/Frame 108 (2).871637a3.svg";